<template>
  <router-view />
</template>

<script>
export default {
  name: 'SchemeBusinessNotesRouter',
};
</script>
